import React from "react";
import styled from "styled-components";
import { ButtonFilled, Body, Header } from "../../../styleguide/atoms";
import * as styles from "../../../styleguide/styles/Stylesheet";
import { api } from "../../../lib/gameApi";

const Section = styled.section`
  margin: ${styles.spacing_standard_large} 0;
`;

const ButtonWrapper = styled.div`
  margin: ${styles.spacing_standard} 0;
`;

export default function DeleteData() {
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState("");
  const [success, setSuccess] = React.useState(false);

  async function handleClick() {
    const confirm = window.confirm(
      "This will permanently delete your game data on Summer Camp Slasher. This cannot be undone. Continue?"
    );
    if (!confirm) return;

    setLoading(true);
    setError("");
    setSuccess(false);
    try {
      const result = await api.deleteData();
      if (result?.ok) {
        setSuccess(true);
      } else {
        setError("Something went wrong deleting your data.");
      }
    } catch (e) {
      console.error(e);
      setError(e.message || "Something went wrong deleting your data.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <Section>
      <Header type="h2" align="left">
        Delete my data
      </Header>
      <Body color={styles.color_gry_6}>
        Player information and game data are automatically deleted approximately
        24 hours after creation. You can also click the button below to manually
        delete any data associated with your device/user ID (players, chats,
        votes, and logs).
      </Body>
      <ButtonWrapper>
        <ButtonFilled
          text={loading ? "Deleting..." : "Delete my data"}
          onClick={handleClick}
          disabled={loading}
        />
      </ButtonWrapper>
      {error && <Body color={styles.color_red}>{error}</Body>}
      {success && (
        <Body color={styles.color_green}>
          Your data has been deleted. You may need to refresh the page.
        </Body>
      )}
    </Section>
  );
}
